/**
 * @generated SignedSource<<428a2533108410d1e423edba590d8222>>
 * @relayHash 6497568be6ce284a49fd2f4d709672b7
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6497568be6ce284a49fd2f4d709672b7

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type WebNotificationKind = "APPOINTMENT_CONCLUSION_FAILED" | "PATIENT_FILE_LOCK_REQUESTED" | "PATIENT_FILE_LOCK_TAKEN";
export type useWebNotificationsSubscription$variables = Record<PropertyKey, never>;
export type useWebNotificationsSubscription$data = {
  readonly webNotifications: {
    readonly actionTriggeredBy: string | null;
    readonly appointment: {
      readonly chatDetails: {
        readonly chatThreadId: string;
      } | null;
      readonly id: string;
    } | null;
    readonly kind: WebNotificationKind;
    readonly notificationId: string;
    readonly patient: {
      readonly country: Country;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null;
  };
};
export type useWebNotificationsSubscription = {
  response: useWebNotificationsSubscription$data;
  variables: useWebNotificationsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionTriggeredBy",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Appointment",
  "kind": "LinkedField",
  "name": "appointment",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentChatDetails",
      "kind": "LinkedField",
      "name": "chatDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chatThreadId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWebNotificationsSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WebNotification",
        "kind": "LinkedField",
        "name": "webNotifications",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useWebNotificationsSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WebNotification",
        "kind": "LinkedField",
        "name": "webNotifications",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6497568be6ce284a49fd2f4d709672b7",
    "metadata": {},
    "name": "useWebNotificationsSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "6bcce04ea971ed9df38625d0bf2d06df";

export default node;
